import React, { useEffect, useState } from 'react';
import { List, ListItem, useMediaQuery } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useDispatch, useSelector } from 'react-redux';
import api from '../api/api';
import { setUserDetails } from '../redux/userSlice';
import { sidebarListItems } from '../utils/sidebarList';

const CustomSideNav = ({ isCollapsed, setIsCollapsed }) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const user = useSelector(state => state.user.userDetails);
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState(null);
  const [tokenChecked, setTokenChecked] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const accessToken = queryParams.get('allow');
    if (accessToken) setToken(accessToken);
    setTokenChecked(true);
  }, [location.search]);

  useEffect(() => {
    const fetchUserRole = async () => {
      
      try {
        setLoading(true);
        const response = await api.get('/auth/me');

        dispatch(setUserDetails(response));
      } catch (error) {
        console.error('Failed to fetch user role:', error);
      } finally {
        setLoading(false);
      }
    };

    if (!user?.user_roles && !token) fetchUserRole();
  }, [user, token, dispatch]);

  const miniSidenav = isCollapsed;

  useEffect(() => {
    setIsCollapsed(isMobile);
  }, [isMobile, setIsCollapsed]);

  const handleCollapse = () => setIsCollapsed(prev => !prev);
// Map permissions to sidebar items
const userPermissions = user?.user_info?.permissions || [];




const allSidebarItems = sidebarListItems(token);


const filteredNavItems = allSidebarItems.filter(item => {
  const hasPermission = userPermissions.includes(item.id.toString());
 
  return hasPermission;
});

  return (
    <>
      <style>
        {`
          .sidenav-item:hover {
            background-color: rgb(17, 30, 74);
            color: white;
          }  
          .sidenav-item:hover .sidenavlabel {
            color: white;
          }  
          .sidenav-item:hover .sidenav-icon {
            color: black;
          }  
        `}
      </style>

      <div
        className={`min-h-[70vh] max-h-[88vh] overflow-auto  bg-[#ffffff] rounded-b-lg shadow-[0px_14px_42px_0px_rgba(0,_0,_0,_0.06)] transition-all ${miniSidenav ? 'w-[50px]' : 'w-[14%]'}`}
      >
        <div className={`flex items-center ${miniSidenav ? 'justify-center' : 'justify-end'}`}>
          <div onClick={handleCollapse} style={{ cursor: 'pointer' }}>
            {miniSidenav ? (
              <ArrowForwardIosIcon className="mt-2 rounded-full w-3 h-3" />
            ) : (
              <ArrowBackIosIcon className="mt-2 rounded-full w-3 h-3" />
            )}
          </div>
        </div>

        <div className="flex flex-col items-center justify-center w-full">
          <List className="w-full flex flex-col items-center gap-2">
            {filteredNavItems.map((item, index) => {
              const isActive =
                location.pathname === new URL(item.path, window.location.origin).pathname;
              return (
                <ListItem
                  key={index}
                  className={`sidenav-item hover:bg-[#111E4A] cursor-pointer rounded-[8px] ${
                    isActive ? 'bg-[#145388] shadow-md' : ''
                  }`}
                  button
                  style={{ padding: '10px 0px', width: '95%' }}
                  onClick={() => navigate(item.path)}
                >
                  <div
                    className={`sidenav-icon shadow-custom-light ${miniSidenav ? 'ml-[8px]' : 'ml-[12px]'}`}
                    style={{ width: 'auto', backgroundColor: 'white', padding: '5px', borderRadius: '8px' }}
                  >
                    {item.icon}
                  </div>
                  {!miniSidenav && (
                    <div
                      className={`sidenavlabel font-semibold font-tahoma ml-4 ${
                        isActive ? 'text-[white]' : 'text-[black]'
                      } text-md leading-normal`}
                    >
                      {item.label}
                    </div>
                  )}
                </ListItem>
              );
            })}
          </List>
        </div>
      </div>
    </>
  );
};

export default CustomSideNav;
